import layoutHeaderAside from '@/layout/header-aside'
import bus from '@/components/view-bus'
// import bus from '@/components/view-bus'
const _import = require('@/libs/util.import.' + process.env.NODE_ENV)
// 信鸽路由
export default [
  {
    path: '/matchlist',
    name: 'matchlist',
    meta: {
      title: '赛事中心',
      auth: true
    },
    // component: _import('payfee/prepay')
    redirect: { name: 'MatchIndex' },
    component: layoutHeaderAside,
    children: [
      {
        path: 'match',
        name: 'Match',
        meta: {
          title: '赛事中心',
          auth: true
        },
        redirect: { name: 'MatchIndex' },
        component: bus,
        children: [
          {
            path: 'index',
            name: 'MatchIndex',
            meta: {
              title: '赛事中心',
              auth: true
            },
            component: _import('match/match')
          },

          {
            path: 'matchAdd',
            name: 'MatchAdd',
            meta: {
              title: '新建赛事',
              auth: true
            },
            component: _import('match/match-info')
          },
          {
            path: 'matchEdit',
            name: 'MatchEdit',
            meta: {
              title: '编辑赛事',
              auth: true
            },
            component: _import('match/match-info')
          },
        ]
      }
    ]
  }
]
